module.exports = __webpack_public_path__ + "static/media/blocker_assign.ada3b142.png";